import React from 'react';
import techLeft from '../img/png/tech_background_left.png';
import techRight from '../img/png/tech_background_right.png';

function Teachnology() {
  return (
    <>
      <section
        id='technology'
        className='technology d-flex align-items-center justify-content-center'
      >
        <div className='technology_container d-flex-col align-items-center justify-content-center gap-2 text-center'>
          <h2 className='text-title'>Technology</h2>
          <p className='text-gray'>
            Our AI does not require machine learning or training. It is one of
            the world’s first market applications of artificial general
            intelligence where the machine autonomously acquires its knowledge
            in any area that it is applied.
          </p>
          <p className='text-gray'>
            We don’t have a database schema defining a person as a unique
            entity.
            <br /> By focusing uniquely on behaviours we have the capability to
            measure groups without processing the individuals that comprise
            them.
          </p>
          <div className='line'></div>
        </div>
        <div className='technology_background d-flex justify-content-between'>
          <div className='technology_background_left d-flex align-items-center'>
            <img src={techLeft} alt='background' />
          </div>
          <div className='technology_background_right d-flex align-items-center'>
            <img src={techRight} alt='background' />
          </div>
        </div>
      </section>
    </>
  );
}

export default Teachnology;
